import axios, { AxiosResponse } from 'axios';

export const useApplyDiscountCodeAction = () => {
  return async (code: string): Promise<AxiosResponse> => {
    return axios.get(`/discount/${code}`);
  };
};
